import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentforjyotilinga() {



    const cardData =
    {
        keyword: 'Urbania on Rent for Jyotirlinga Darshan from Pune',
        heading: 'Urbania on rent in pune: Urbania on Rent for Jyotirlinga Darshan from Pune',
        headingDescription: 'Urbania On Rent in Pune offers premium and reliable Urbania on Rent for Jyotirlinga Darshan from Pune for pilgrims, families, corporate groups, and travelers planning spiritual journeys. Our well‑maintained Force Urbania fleet provides spacious seating, air‑conditioned comfort, and smooth performance, making it ideal for comfortable travel to Jyotirlinga temples across Maharashtra. With professional chauffeurs, flexible one‑way and round‑trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress‑free pilgrimage experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for Jyotirlinga Darshan Urbania hire from Pune.',

        top: 'Top Places to Visit in Pune with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by Peshwa Bajirao I, is Pune’s iconic fort and a symbol of Maratha heritage. The massive stone walls, grand gateways such as the Delhi Darwaza, and sprawling lawns showcase the grandeur of the Peshwa era. Though much of it was destroyed in a fire, the remnants still reflect royal architecture and historical significance. The evening light-and-sound show vividly narrates Maratha history, making it a must-visit site for history enthusiasts and tourists alike."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892, Aga Khan Palace is closely tied to India’s freedom struggle, as Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now serves as a museum displaying Gandhi’s personal artifacts, photographs, and letters. Its expansive gardens, Italian arches, and serene atmosphere offer a peaceful retreat while preserving the legacy of sacrifice and patriotism."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is renowned for the historic 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors can trek or drive to the fort, explore ancient ramparts, memorials, and enjoy panoramic views of the Sahyadri ranges. Local vendors serve traditional pithla-bhakri meals, making the experience a blend of history, adventure, and local culture."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual landmark, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily, especially during Ganesh Chaturthi when grand celebrations are held. The temple trust is also known for charitable activities, making it a center of devotion, spirituality, and community service."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic city views after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines, a museum, and tranquil surroundings make it a favorite spot for spiritual seekers, photographers, and tourists. Sunrise and sunset visits provide breathtaking vistas."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, an 8th-century rock-cut shrine, is dedicated to Lord Shiva and carved from a single basalt rock. The temple features monolithic pillars, a circular Nandi pavilion, and a peaceful sanctum. Despite its urban location, it retains a tranquil ambiance, showcasing ancient Indian craftsmanship and providing a quiet spiritual retreat for visitors."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, offering a comprehensive glimpse into India’s cultural past. From traditional musical instruments, ornaments, and household antiques to sculptures and paintings, the museum is a treasure trove of art and heritage. The recreated Mastani Mahal is a major highlight, making it Pune’s living archive of craftsmanship."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for meditation, wellness, and spiritual transformation. Spread across landscaped gardens, it offers guided meditation sessions, holistic therapies, and mindfulness programs. Visitors from around the world come seeking relaxation, inner peace, and rejuvenation in a serene and luxurious environment."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, arched bridges, manicured lawns, and seasonal flowerbeds. The garden is ideal for leisurely walks, photography, and family outings, blending Japanese aesthetics with Indian greenery to create a peaceful and picturesque urban sanctuary."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a favorite leisure spot near Pune. Surrounded by hills and expansive water views, it is especially picturesque during the monsoon. Visitors enjoy street food, sunset views, and relaxed outings. The dam also serves as the starting point for treks to Sinhagad Fort, making it a hub for both relaxation and adventure."
  }
],






"services": [
{
"name": "Urbania on Rent for Jyotirlinga Darshan from Pune",
"description": "Urbania on Rent for Jyotirlinga Darshan from Pune offers reliable and comfortable buses for pilgrimage tours to the Jyotirlinga temples. Perfect for families, groups, and corporate travelers, these buses provide spacious seating, professional chauffeurs, and hassle-free travel for a spiritually enriching journey."
},
{
"name": "Jyotirlinga Darshan Urbania Hire Pune",
"description": "Jyotirlinga Darshan Urbania Hire Pune provides convenient rental services for AC and non-AC Urbania buses specifically for Jyotirlinga temple tours. Ensures safety, comfort, and timely travel for families, friends, and corporate groups undertaking religious journeys."
},
{
"name": "Urbania Bus for Jyotirlinga Tour Pune",
"description": "Urbania Bus for Jyotirlinga Tour Pune offers well-maintained buses for long-distance pilgrimage travel. Features include comfortable seating, luggage support, and experienced drivers familiar with temple routes, ensuring a smooth and memorable Jyotirlinga Darshan."
},
{
"name": "Pune Jyotirlinga Darshan Urbania Rental",
"description": "Pune Jyotirlinga Darshan Urbania Rental provides flexible bus rental options for Jyotirlinga tours, catering to families, friends, and corporate groups. Offers professional drivers, AC and non-AC buses, and reliable service for a stress-free religious trip."
},
{
"name": "Urbania AC Bus Jyotirlinga Tour",
"description": "Urbania AC Bus Jyotirlinga Tour offers fully air-conditioned buses for comfortable and long-distance travel to Jyotirlinga temples. Ensures smooth rides, climate-controlled interiors, and experienced chauffeurs for a peaceful pilgrimage."
},
{
"name": "Family Jyotirlinga Darshan Urbania Pune",
"description": "Family Jyotirlinga Darshan Urbania Pune provides buses designed for family groups, ensuring comfort, safety, and a pleasant travel experience during visits to Jyotirlinga temples. Features spacious seating and courteous drivers."
},
{
"name": "Corporate Jyotirlinga Darshan Urbania Pune",
"description": "Corporate Jyotirlinga Darshan Urbania Pune delivers organized bus transport for corporate groups participating in Jyotirlinga pilgrimages. Offers AC buses, trained chauffeurs, and timely pickups for a seamless group travel experience."
},
{
"name": "Luxury Urbania Jyotirlinga Tour",
"description": "Luxury Urbania Jyotirlinga Tour provides high-end air-conditioned buses with plush seating, modern interiors, and professional drivers for VIP and luxury pilgrimage travel. Perfect for families and corporate groups seeking a premium experience."
},
{
"name": "Affordable Jyotirlinga Darshan Urbania Pune",
"description": "Affordable Jyotirlinga Darshan Urbania Pune offers budget-friendly bus rental options for Jyotirlinga tours without compromising on safety, comfort, or convenience. Ideal for groups and families seeking economical travel solutions."
},
{
"name": "Chauffeur Driven Urbania Jyotirlinga Tour",
"description": "Chauffeur Driven Urbania Jyotirlinga Tour ensures a stress-free pilgrimage with verified and experienced drivers. Perfect for families, corporate groups, and tourists who want a safe and smooth journey to Jyotirlinga temples."
},
{
"name": "Best Jyotirlinga Darshan Urbania Package Pune",
"description": "Best Jyotirlinga Darshan Urbania Package Pune provides top-rated buses and service for Jyotirlinga tours. Features punctual pickups, comfortable seating, professional drivers, and organized itineraries for a memorable pilgrimage experience."
},
{
"name": "Group Travel Jyotirlinga Urbania",
"description": "Group Travel Jyotirlinga Urbania offers large-capacity buses for group pilgrimages to Jyotirlinga temples. Ensures safe, convenient, and comfortable travel for friends, families, and corporate groups."
},
{
"name": "Pilgrimage Urbania Hire Pune",
"description": "Pilgrimage Urbania Hire Pune provides specialized bus rental services for religious journeys, including Jyotirlinga tours. Offers professional drivers, AC buses, and organized travel for a spiritually fulfilling experience."
},
{
"name": "Pune Jyotirlinga Darshan Bus Booking",
"description": "Pune Jyotirlinga Darshan Bus Booking allows easy reservation of Urbania buses for Jyotirlinga temple tours. Ensures timely pickups, comfortable travel, and courteous drivers for hassle-free pilgrimage transportation."
},
{
"name": "Trusted Jyotirlinga Urbania Service",
"description": "Trusted Jyotirlinga Urbania Service provides reliable and secure bus rental options for Jyotirlinga tours from Pune. Features AC and non-AC buses, professional chauffeurs, and excellent customer support for a worry-free pilgrimage journey."
}
],
"tableData": [
["Urbania on Rent for Jyotirlinga Darshan from Pune", "Jyotirlinga Darshan Urbania Hire Pune"],
["Urbania Bus for Jyotirlinga Tour Pune", "Pune Jyotirlinga Darshan Urbania Rental"],
["Urbania AC Bus Jyotirlinga Tour", "Family Jyotirlinga Darshan Urbania Pune"],
["Corporate Jyotirlinga Darshan Urbania Pune", "Luxury Urbania Jyotirlinga Tour"],
["Affordable Jyotirlinga Darshan Urbania Pune", "Chauffeur Driven Urbania Jyotirlinga Tour"],
["Best Jyotirlinga Darshan Urbania Package Pune", "Group Travel Jyotirlinga Urbania"],
["Pilgrimage Urbania Hire Pune", "Pune Jyotirlinga Darshan Bus Booking"],
["Trusted Jyotirlinga Urbania Service", ""]
],



"whychoose": [
    {
        "WhyChooseheading": "Urbania on Rent for Jyotirlinga Darshan from Pune",
        "WhyChoosedescription": "Urbania on Rent for Jyotirlinga Darshan from Pune is perfect for spiritual journeys, group travel, family pilgrimages, corporate trips, and outstation tours, offering comfort and spacious seating."
    },
    {
        "WhyChooseheading": "Spacious and Well-Equipped Urbania Vehicles",
        "WhyChoosedescription": "Urbania on Rent for Jyotirlinga Darshan from Pune provides modern Force Urbania vehicles with air-conditioning, ample legroom, comfortable seating, and luggage space for long-distance pilgrimages."
    },
    {
        "WhyChooseheading": "Experienced and Reliable Drivers",
        "WhyChoosedescription": "All Urbania vehicles come with trained and experienced drivers familiar with Pune, Nashik, Shirdi, and nearby pilgrimage routes, ensuring safe, punctual, and hassle-free travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Choose Urbania on Rent for Jyotirlinga Darshan from Pune for competitive rates with no hidden charges, making spiritual travel cost-effective and enjoyable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania on Rent for Jyotirlinga Darshan from Pune offers round‑the‑clock booking assistance and dedicated customer support for inquiries, reservations, and last‑minute travel needs."
    },
    {
        "WhyChooseheading": "Flexible Darshan Travel Packages",
        "WhyChoosedescription": "Urbania on Rent for Jyotirlinga Darshan from Pune is available for single‑day trips, multi‑day pilgrimages, customized routes, corporate travel, and family tours."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well‑Maintained Vehicles",
        "WhyChoosedescription": "All vehicles for Urbania on Rent for Jyotirlinga Darshan from Pune are regularly cleaned, sanitized, and maintained to ensure passenger safety and comfort."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania on Rent for Jyotirlinga Darshan from Pune guarantees on‑time pickups and dependable service, ensuring smooth and stress‑free spiritual travel experiences."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania on Rent for Jyotirlinga Darshan from Pune available for local and outstation travel?',
        answer: 'Yes, Urbania on Rent for Jyotirlinga Darshan from Pune can be booked for pilgrimages, city travel, corporate trips, family outings, and long‑distance journeys.',
    },
    {
        question: 'How can I book Urbania on Rent for Jyotirlinga Darshan from Pune?',
        answer: 'You can book Urbania on Rent for Jyotirlinga Darshan from Pune via phone, WhatsApp, or online for quick and easy reservations.',
    },
    {
        question: 'Why should I choose Urbania on Rent for Jyotirlinga Darshan from Pune?',
        answer: 'This service offers spacious seating, professional drivers, clean vehicles, transparent pricing, and flexible travel plans for pilgrimage tours.',
    },
    {
        question: 'Are drivers experienced for pilgrimage routes?',
        answer: 'Yes, all drivers for Urbania on Rent for Jyotirlinga Darshan from Pune are licensed, trained, and experienced in handling long‑distance pilgrimage routes safely.',
    },
    {
        question: 'Can pickup and drop‑off locations be customized?',
        answer: 'Absolutely. Urbania on Rent for Jyotirlinga Darshan from Pune allows flexible pickup and drop locations across Pune and nearby areas.',
    },
    {
        question: 'Is Urbania on Rent for Jyotirlinga Darshan from Pune available 24x7?',
        answer: 'Yes, bookings and customer support are available 24x7 for your convenience.',
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all vehicles are regularly cleaned, sanitized, and maintained to ensure passenger safety and comfort.',
    },
    {
        question: 'What payment options are available?',
        answer: 'Urbania on Rent for Jyotirlinga Darshan from Pune accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout your spiritual trip for a hassle‑free experience.',
    },
    {
        question: 'Is this service suitable for family, corporate, and group pilgrimages?',
        answer: 'Yes, Urbania on Rent for Jyotirlinga Darshan from Pune is ideal for family pilgrimages, corporate group tours, and group travels to multiple Jyotirlinga sites.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Sandeep Kulkarni',
        feedback: 'Urbania on Rent for Jyotirlinga Darshan from Pune provided an excellent and comfortable ride for our pilgrimage journey. Very spacious and reliable service.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Priya Deshpande',
        feedback: 'We booked this for a multi‑day Jyotirlinga trip. The journey was smooth, buses were clean, and the drivers were very professional.',
        rating: 5,
    },
    {
        id: 3,
        name: 'Mr. Amit Patil',
        feedback: 'Our spiritual tour was hassle‑free and memorable thanks to Urbania on Rent for Jyotirlinga Darshan from Pune. Highly recommended.',
        rating: 5,
    },
];





































































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania on Rent for Jyotirlinga Darshan from Pune",
  "image": "https://urbaniaonrentpune.in/assets/images/jyotirlinga-darshan-urbania.jpg",
  "description": "Urbania on Rent for Jyotirlinga Darshan from Pune offers AC Urbania buses for family trips, corporate travel, group tours, and pilgrimage journeys. Chauffeur-driven Urbania buses provide safe, comfortable, and convenient transportation for visiting Jyotirlinga temples from Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-on-rent-jyotirlinga-darshan-pune"
  }
};




    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania on Rent for Jyotirlinga Darshan from Pune | AC Urbania Bus Tour 
  </title>

  <meta
    name="description"
    content="Book Urbania on Rent for Jyotirlinga Darshan from Pune for family trips, corporate tours, group travel, and pilgrimage journeys. AC Urbania buses with chauffeur-driven service provide safe, comfortable, and convenient travel for visiting Jyotirlinga temples from Pune."
  />

  <meta
    name="keywords"
    content="Urbania on Rent for Jyotirlinga Darshan from Pune, Jyotirlinga Darshan Urbania Hire Pune, Urbania Bus for Jyotirlinga Tour Pune, Pune Jyotirlinga Darshan Urbania Rental, Urbania AC Bus Jyotirlinga Tour, Family Jyotirlinga Darshan Urbania Pune, Corporate Jyotirlinga Darshan Urbania Pune, Luxury Urbania Jyotirlinga Tour, Affordable Jyotirlinga Darshan Urbania Pune, Chauffeur Driven Urbania Jyotirlinga Tour, Best Jyotirlinga Darshan Urbania Package Pune, Group Travel Jyotirlinga Urbania, Pilgrimage Urbania Hire Pune, Pune Jyotirlinga Darshan Bus Booking, Trusted Jyotirlinga Urbania Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/81.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaonrentforjyotilinga;